const LoadIdentifyIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  const fillColor = isActive ? "#01BBFE" : "white";
  const gradientStart = isActive ? "#68D7FF" : "white";
  const gradientStop = isActive ? "#68D7FF" : "white";
  const backgroundFill = isActive ? "#68D7FF" : "#9EA6B2";
  const backgroundOpacity = isActive ? 0.2 : 0.3;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="28" cy="28" r="27" fill={backgroundFill} fillOpacity={backgroundOpacity} />
      <circle cx="28" cy="28" r="27" stroke={`url(#bubble-stroke)`} strokeWidth="2" />
      <path
        d="M36.2453 25.4088C36.2203 23.3724 34.5928 21.7273 32.5834 21.7273C32.0532 21.7273 31.5503 21.8446 31.0957 22.045C30.1967 20.2428 28.3295 19 26.1649 19C23.1284 19 20.6668 21.4415 20.6668 24.4546C18.6417 24.4543 17 26.0825 17 28.0909C17 30.099 18.6418 31.7271 20.6666 31.7271H25.25V27.1816H23.875L26.1666 23.5453L28.4582 27.1816H27.0831V31.7271H28.9166V35.3626H27.5416L29.8332 39L32.125 35.3626H30.75V31.7271H35.7916C37.5631 31.7271 39 30.3041 39 28.5452C39 26.9429 37.8005 25.6298 36.2453 25.4088Z"
        fill={fillColor}
      />
      <defs>
        <linearGradient id="bubble-stroke" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LoadIdentifyIcon;
